import { onMounted, onBeforeUnmount } from 'vue';

// iOS Safari nao redimensiona o layout quando o teclado abre (Android sim):
// o visualViewport encolhe e o rodape fica escondido atras do teclado.
// Publica a diferenca como --kbd-safe pro CSS empurrar o composer pra cima.
// No Android o innerHeight encolhe junto, entao o offset fica ~0 e nada muda.
export function useIosKeyboardOffset() {
  const update = () => {
    const vv = window.visualViewport;
    if (!vv) return;

    const offset = Math.max(0, window.innerHeight - vv.height - vv.offsetTop);
    document.documentElement.style.setProperty(
      '--kbd-safe',
      `${Math.round(offset)}px`
    );
  };

  onMounted(() => {
    if (!window.visualViewport) return;

    window.visualViewport.addEventListener('resize', update);
    window.visualViewport.addEventListener('scroll', update);
    update();
  });

  onBeforeUnmount(() => {
    if (!window.visualViewport) return;

    window.visualViewport.removeEventListener('resize', update);
    window.visualViewport.removeEventListener('scroll', update);
    document.documentElement.style.removeProperty('--kbd-safe');
  });
}
